<template>
    <el-dialog class="img" :visible.sync="isShowImageDialog" @closed="clearImg" title='图片查看'>
        <el-carousel indicator-position="outside" min-height="300" :arrow = "spanshow">
            <el-carousel-item v-for="(src,index) in imgs" :key="index" >
                <img  :src="src"  style="max-width: 100%;height: 300px;display: block; margin: 0 auto;" />
            </el-carousel-item>
        </el-carousel>
    </el-dialog>
</template>

<script>
export default {
    name: 'ImgPreview',
    data() {
        return {
            imgs: '',
            isShowImageDialog: false,
            spanshow:"never"
        }
    },
    methods: {
        clearImg() {
            this.imgs = null
        },
    }
}
</script>
<style>
.img .el-carousel__container{
    height: 300px
}
</style>
<style scoped>

</style>



// WEBPACK FOOTER //
// ImgPreview.vue?1b079192